<template>
  <div class="notice pt7 pl2 pr5 bc-white" v-title data-title="公告">
    <van-field
      center
      label="位置"
    >
      <template #input>
        <select class="notice-select" v-model="notice.position" placeholder="请选择位置">
          <option v-for="ps in positions" :value ="ps.value" :key="ps.value">
            {{ps.text}}
          </option>
        </select>
      </template>
    </van-field>

    <van-field
      v-model="notice.content"
      clearable
      label="公告内容"
      placeholder="请输入公告内容"
      type="textarea"
      rows="2"
      autosize
      center
    />
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <van-button @click="save" class="btn-common" type="info" :loading="loading" loading-text="正在保存...">保存</van-button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { NOTICE_TYPES } from '@/uitls/const';
import config from '../../config';
import {
  sendRequest, savenotice, getnotice,
} from '../../network/NetworkAccessor';

export default Vue.extend({
  name: 'notice',
  components: {},
  data() {
    return {
      loading: false,
      fileDomain: config.FILE_DOMAIN,
      notice: {
        position: '',
      },
      positions: [
        {
          text: '请选择',
          value: '',
        },
        ...NOTICE_TYPES,
      ],
    };
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    save() {
      sendRequest(savenotice, this.notice).then((res) => {
        // this.$router.back();
        this.back();
      }).catch((error) => {
        this.$dialog.alert({
          message: error.message || '啊哦，出错了',
        });
      });
    },
    back() {
      // this.$router.push('/notice/info/list');
      this.$router.back();
    },
    getNotice() {
      // console.log('------------', this.id);
      if (!this.id) {
        return;
      }
      sendRequest(getnotice, { id: this.id }).then((res) => {
        this.notice = {
          ...res,
          position: res.position || '',
        };
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
  },
  created() {
    this.getNotice();
  },
});
</script>
<style scoped>
  .notice {
    min-height: 100vh;
  }
  .notice >>> .van-uploader__upload,.notice >>> .van-uploader__preview{
    width: 100%;
  }
  .notice >>> .van-uploader__preview-image{
    width: 100%;
  }
  .notice-select {
    /* font-size: 15px; */
    /* border: 1px solid #eee; */
    text-align: left;
    text-align-last: left;
    width: 100%;
    border: 0;
    /* padding: 8px 0; */
    height: 30px;
  }
  .notice >>> .van-uploader__file {
    width: 100%;
  }
  .notice >>> .van-uploader__preview-image {
    height: auto;
  }
</style>
